import { CircularProgress } from '@mui/material';
import './styles.scss';

export const NoItems = ()=>{
    return (<div id='no-items'><p>No Items to Show....</p></div>);
}